import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { dominioEmpresaBeneficiosContratacao, dominioEmpresaBeneficiosContratacaoWebp, dominioEmpresaCobrancasContratacao, dominioEmpresaCobrancasContratacaoWebp, dominioEmpresaContabilidadeContratacao, dominioEmpresaContabilidadeContratacaoWebp, dominioEmpresaContaPjContratacao, dominioEmpresaContaPjContratacaoWebp, } from '@ibk/shared-assets';
import { ApiProductStatus, ProductAlias } from '@ibk/shared-types';
import { useHappyHolidaysHomeBanner } from '../../ProductBanners/hooks/useHappyHolidaysHomeBanner';
const createBeneficiosBanner = (navigate) => ({
    id: 'home-beneficios-contratacao',
    image: dominioEmpresaBeneficiosContratacao,
    webpImage: dominioEmpresaBeneficiosContratacaoWebp,
    productAlias: ProductAlias.BENEFICIOS,
    isForNonContracted: true,
    onClick: () => {
        navigate('/beneficios');
    },
});
const createContabilidadeBanner = (navigate) => ({
    id: 'home-contabilidade-contratacao',
    image: dominioEmpresaContabilidadeContratacao,
    webpImage: dominioEmpresaContabilidadeContratacaoWebp,
    productAlias: ProductAlias.CONTABILIDADE_DIGITAL,
    isForNonContracted: true,
    onClick: () => {
        navigate('/contabilidade-digital/contas-conectadas');
    },
});
const createCobrancasBanner = (navigate) => ({
    id: 'home-cobrancas-contratacao',
    image: dominioEmpresaCobrancasContratacao,
    webpImage: dominioEmpresaCobrancasContratacaoWebp,
    productAlias: ProductAlias.COBRANCAS,
    isForNonContracted: true,
    onClick: () => {
        navigate('/cobrancas');
    },
});
const createContaPjBanner = () => ({
    id: 'home-conta-pj-contratacao',
    image: dominioEmpresaContaPjContratacao,
    webpImage: dominioEmpresaContaPjContratacaoWebp,
    productAlias: ProductAlias.CONTA_DIGITAL,
    isForNonContracted: true,
});
const isProductAvailable = (product) => !product.isLoading && !product.error;
const isProductContracted = (product) => product.data?.status === ApiProductStatus.ACTIVE;
const isProductActive = (product) => isProductAvailable(product) && isProductContracted(product);
export const useHomeProductBanners = ({ productsData, domain, isActive = true, hasBillingPermission, isBillingProductAvailable, includeHappyHolidaysBanner = true, }) => {
    const navigate = useNavigate();
    const happyHolidaysBanner = useHappyHolidaysHomeBanner(productsData.products[ProductAlias.BENEFICIOS], isActive && domain === 'empresa' && includeHappyHolidaysBanner);
    return useMemo(() => {
        if (!isActive || domain !== 'empresa') {
            return [];
        }
        const banners = [];
        if (happyHolidaysBanner) {
            banners.push({ ...happyHolidaysBanner, isForNonContracted: false });
        }
        const { products } = productsData;
        const contaPjProduct = products[ProductAlias.CONTA_DIGITAL];
        const hasContaPjActive = isProductActive(contaPjProduct);
        if (isProductAvailable(contaPjProduct) && !isProductContracted(contaPjProduct)) {
            banners.push(createContaPjBanner());
        }
        const beneficiosProduct = products[ProductAlias.BENEFICIOS];
        if (isProductAvailable(beneficiosProduct)) {
            const isContracted = isProductContracted(beneficiosProduct);
            if (!isContracted) {
                banners.push(createBeneficiosBanner(navigate));
            }
        }
        const contabilidadeProduct = products[ProductAlias.CONTABILIDADE_DIGITAL];
        if (isProductAvailable(contabilidadeProduct)) {
            const isContracted = isProductContracted(contabilidadeProduct);
            if (isContracted) {
                banners.push(createContabilidadeBanner(navigate));
            }
        }
        const cobrancasProduct = products[ProductAlias.COBRANCAS];
        if (isProductAvailable(cobrancasProduct)) {
            const isContracted = isProductContracted(cobrancasProduct);
            const isBillingActive = isBillingProductAvailable && isContracted;
            if (hasBillingPermission && !isBillingActive && hasContaPjActive) {
                banners.push(createCobrancasBanner(navigate));
            }
        }
        return banners;
    }, [productsData, domain, isActive, navigate, hasBillingPermission, isBillingProductAvailable, happyHolidaysBanner]);
};
